
import { DEFAULT_IMAGE } from "@/lib/config/cdn";

interface PropertyImageThumbnailProps {
  image: string;
  index: number;
  currentSlide: number; 
  onClick: (index: number) => void;
  title: string;
}

const PropertyImageThumbnail = ({ 
  image, 
  index, 
  currentSlide, 
  onClick,
  title 
}: PropertyImageThumbnailProps) => {
  const isActive = index === currentSlide;
  
  return (
    <div 
      className={`h-full aspect-video flex-shrink-0 cursor-pointer transition-all ${
        isActive ? 'border-2 border-white' : 'opacity-70 hover:opacity-100'
      }`}
      onClick={() => onClick(index)}
    >
      <img 
        src={image} 
        alt={`${title} - Thumbnail ${index + 1}`} 
        className="h-full w-full object-cover"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.onerror = null;
          target.src = DEFAULT_IMAGE;
        }}
      />
    </div>
  );
};

export default PropertyImageThumbnail;
